module.exports = __webpack_public_path__ + "static/media/030.1bc4056e.jpg";